import Util from '@/js/common/Util';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CheckBox from './CheckBox';

export type checkStateType = "allCheck" | "check" | "noCheck"

interface GroupCheckBoxProps {
    checkState: checkStateType
    onChange?: Function
    buttonColor?: string
    buttonClassName?: string
    borderWidth?: number
    borderColor?: string
    borderOnColor?: string
}
const GroupCheckBox = ({checkState, onChange, buttonColor, buttonClassName, borderWidth, borderColor, borderOnColor}: GroupCheckBoxProps) => {
    const onChangeFunc = (e: any) => {
        if (!onChange) {
            return;
        }
        onChange(e);
    }

    const CheckBoxEl = () => {
        if (checkState === "allCheck") {
            return (
                <CheckBox onChange={onChangeFunc} buttonColor={buttonColor} buttonClassName={buttonClassName} borderWidth={borderWidth} borderColor={borderColor} borderOnColor={borderOnColor} checked={true} />
            )
        } else if (checkState === "check") {
            return (
                <button style={{background: buttonColor}} className={"bdN w16 h16 p0 dpFlx aiC jcC " + (Util.isNotEmpty(buttonClassName) ? buttonClassName : "")} onClick={onChangeFunc}>
                    <FiberManualRecordIcon style={{width: 10, height: 10, color: "#fff"}} />
                </button>
            )
        } else if (checkState === "noCheck") {
            return (
                <CheckBox onChange={onChangeFunc} buttonColor={buttonColor} buttonClassName={buttonClassName} borderWidth={borderWidth} borderColor={borderColor} borderOnColor={borderOnColor} checked={false} />
            )
        } else {
            return (<></>)
        }
    }
    return (
        <CheckBoxEl />
    )
}
export default GroupCheckBox;